import { helpers } from '@vuelidate/validators'

export const validatorInArray = (array) =>
  helpers.withParams({ type: 'inArray', array }, value => {
    if (!helpers.req(value)) {
      return true
    }
    return array.indexOf(value) !== -1
  })
